import React from 'react';

const RoleListSidebar = ({ roles, selectedRoleId, onSelect, onCreate }) => {
  const systemRoles = roles.filter((r) => r.is_system);
  const customRoles = roles.filter((r) => !r.is_system);

  const Item = ({ role }) => (
    <button
      key={role.id}
      onClick={() => onSelect(role)}
      className={`w-full text-left px-3 py-2 text-sm rounded-lg flex items-center justify-between ${
        selectedRoleId === role.id
          ? 'bg-primary/10 text-primary font-medium'
          : 'text-foreground hover:bg-muted/50'
      }`}
    >
      <span>{role.label}</span>
      {role.is_system && <span className="text-xs text-muted-foreground">system</span>}
    </button>
  );

  return (
    <div className="w-64 border-r border-border p-3 overflow-y-auto h-full">
      <div className="text-xs font-medium text-muted-foreground uppercase mb-2 px-3">Roles</div>
      <div className="space-y-1">
        {systemRoles.map((r) => <Item key={r.id} role={r} />)}
      </div>
      {customRoles.length > 0 && (
        <>
          <div className="border-t border-border my-3" />
          <div className="space-y-1">
            {customRoles.map((r) => <Item key={r.id} role={r} />)}
          </div>
        </>
      )}
      <button
        onClick={onCreate}
        className="w-full text-left px-3 py-2 mt-3 text-sm text-primary hover:bg-primary/5 rounded-lg"
      >
        + Create role
      </button>
    </div>
  );
};

export default RoleListSidebar;
